import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from "shared/components/Popover";

import { useAssigneeFilter } from "./hooks";
import { AssigneeFilterTrigger } from "./AssigneeFilterTrigger";
import { AssigneeFilterContent } from "./AssigneeFilterContent";

type AssigneeFilterPopoverProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedUserIds: number[] | null;
  onSelectedUserIdsChange: (userIds: number[] | null) => void;
};

export const AssigneeFilterPopover = ({
  open,
  onOpenChange,
  selectedUserIds,
  onSelectedUserIdsChange
}: AssigneeFilterPopoverProps) => {
  const filter = useAssigneeFilter({
    open,
    selectedUserIds,
    onSelectedUserIdsChange
  });

  return (
    <Popover open={open} onOpenChange={onOpenChange} placement="bottom-start">
      <PopoverTrigger onClick={() => onOpenChange(true)}>
        <AssigneeFilterTrigger
          open={open}
          selectedCount={filter.selectedCount}
          displayText={filter.displayText}
          visibleSelectedUsers={filter.visibleSelectedUsers}
          extraSelectedCount={filter.extraSelectedCount}
        />
      </PopoverTrigger>
      <PopoverContent className="max-w-[314px] w-full p-0 rounded-lg border border-alpha-100 shadow-lg bg-content-1000-inverted z-10">
        <AssigneeFilterContent
          search={filter.search}
          onSearchChange={filter.setSearch}
          sortedUsers={filter.sortedUsers}
          isLoading={filter.isLoading}
          selectedUserIds={filter.selectedUserIds}
          authId={filter.auth?.id}
          onToggleUser={filter.handleToggleUser}
          onCancel={() => {
            onSelectedUserIdsChange(null);
            onOpenChange(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
